export default __webpack_public_path__ + "static/media/photo17.934c7c13.jpg";